import { InfoCircleTwoTone } from '@ant-design/icons';
import { Row, Tooltip } from 'antd';

import { Status } from 'components';

import { Transaction } from 'codegen';
import { TColumn } from 'types';

import { BackOutTransaction, RawAction, SendTransaction, UpdateTransaction } from '../Actions';

export const columns = (isAdmin: boolean, refresh: () => void): TColumn<Transaction>[] => [{
  title: 'Sponsor Code',
  dataIndex: 'sponsorCode',
  render: (value, { isEligibleForParticipationOffer }) => (
    <Row>
      {value}

      {isEligibleForParticipationOffer && (
        <Tooltip
          title='There is live Participation offer for transaction Sponsor'
          className='ml-1'
          placement='bottomLeft'
        >
          <InfoCircleTwoTone className='flex items-center' />
        </Tooltip>
      )}
    </Row>
  ),
}, {
  title: 'Total Points',
  dataIndex: 'totalMiles',
}, {
  title: 'Status',
  dataIndex: 'status',
  render: (status, { errors }) => {
    if (errors?.length) {
      return (
        <Tooltip
          title={
            errors.map(({ reason }: { reason: string }, index: number) => (
              <div
                key={reason}
                className='mb-1'
              >
                {index + 1}
                {': '}
                {reason}
              </div>
            ))
          }
        >
          <span>
            <Status status={status} />
          </span>
        </Tooltip>
      );
    }

    return <Status status={status} />;
  },
}, {
  title: 'Type',
  dataIndex: 'type',
}, {
  width: 150,
  title: 'Actions',
  fixed: 'right',
  hidden: !isAdmin,
  render: (_, { id, statusCode, canUpdate, status }) => (
    <>
      <RawAction id={id} />

      <UpdateTransaction
        status={status}
        canUpdate={canUpdate}
        transactionId={id}
        refetchTransactions={refresh}
      />

      <SendTransaction
        status={status}
        statusCode={statusCode}
        transactionId={id}
        refetchTransactions={refresh}
      />

      <BackOutTransaction
        status={status}
        statusCode={statusCode}
        transactionId={id}
        refetchTransactions={refresh}
      />
    </>
  ),
}];
